import ReactDOM from 'react-dom';
/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */

export default function findDOMNode(node) {
  if (node instanceof HTMLElement) {
    return node;
  }

  return ReactDOM.findDOMNode(node);
}


//////////////////
// WEBPACK FOOTER
// ../~/_rc-util@4.11.0@rc-util/es/Dom/findDOMNode.js
// module id = 1436
// module chunks = 0